// extracted by mini-css-extract-plugin
module.exports = {"root":"root___2oJg8","loading":"loading___2Zogw"};